import { Action } from 'redux';
import { findEuropeTimes } from '~/Api/Analytics/VirtualBrand/TimeToPrice';
import { invokeApi, tryResolve } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectTimeToPriceById } from './reducer';

export function fetchEuropeTimeToPrice(id: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findEuropeTimes, id));
		dispatch({ type: ActionTypes.request, request, id });

		await tryResolve(request, (response, error) => {
			dispatch({
				type: ActionTypes.receive,
				request,
				id,
				epar: response?.epar,
				prices: response?.items,
			});
			if (error) {
				dispatch(handleError(error));
			}
		});
	};
}

export function loadEuropeTimeToPrice(id: string): ThunkAction<Promise<void>, any> {
	return async (dispatch, getState) => {
		await (selectTimeToPriceById(getState().medicinalBrandsAnalyticsTimeToPrice, id)?.request ||
			dispatch(fetchEuropeTimeToPrice(id)));
	};
}

export function pruneAll(): Action<ActionTypes.pruneAll> {
	return { type: ActionTypes.pruneAll };
}
